var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-button-group",
    { staticClass: "float-right" },
    [
      _c(
        "b-button",
        {
          staticClass: "btn grey outline",
          attrs: { title: "Download Format" },
          on: { click: _vm.onClickDownload }
        },
        [_c("i", { staticClass: "fa fa-download" })]
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "btn grey outline",
          on: { click: _vm.handleUploadBtnClick }
        },
        [_vm._t("default")],
        2
      ),
      _vm._v(" "),
      _c("input", {
        staticClass: "c-hide",
        attrs: {
          id: _vm.uploadInputId,
          accept: _vm.accept,
          multiple: "",
          type: "file"
        },
        on: { change: _vm.saveFiles }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5b21f816", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b21f816","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/import/jXlsxTable.vue
// module id = null
// module chunks = 